import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '@shared/services/loading.service';
import { catchError, map, throwError } from 'rxjs';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);
  loading.setLoading(true, req.url);

  return next(req).pipe(
    catchError((err) => {
      loading.setLoading(false, req.url);
      return throwError(() => err);
    }),
    map((event) => {
      if (event instanceof HttpResponse) {
        loading.setLoading(false, req.url);
      }
      return event;
    })
  );
};
